module.exports = __webpack_public_path__ + "img/contenedor.642f4ae5.svg";